// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__cPc6Z","modal":"Modal_modal__FnsJn","slide-down":"Modal_slide-down__z1hUK"};